import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  Inject,
  ChangeDetectorRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT, Location } from '@angular/common';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { SignupService } from '../../services/signup.service';
import { ToastrService } from 'ngx-toastr';
import { IPayPalConfig, ICreateOrderRequest } from 'ngx-paypal';
import { OGDetailsObject } from 'src/app/interfaces/shared.model';
import { WatcherService } from 'src/app/services/watcher.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { InstantCalculatorDisocuntCountdownService } from 'src/app/services/instant-calculator-disocunt-countdown.service';
import * as PackageOrdersAction from '../../store/shared/package-order/package-order.actions';
import { BrowserDetectService } from 'src/app/services/browser-detect.service';
import { parse } from 'path';

declare var Stripe: any;
@Component({
  selector: 'app-shipment-details-nohost',
  templateUrl: './shipment-details-nohost.component.html',
  styleUrls: ['./shipment-details-nohost.component.css'],
})
export class ShipmentDetailsNoHostComponent implements OnInit, AfterViewInit {
  timerStart: boolean = false;
  timerFinished: boolean = false;
  isThereADiscount: boolean = false;
  platformLive = false;
  orderLinksList: any = new Set();
  orderOGDetails: OGDetailsObject = {
    scrape: false,
    _url: '',
    title: '',
    description: '',
    type: '',
    site_name: '',
    image: '/assets/img/no-product-image.png',
    url: '',
    name: '',
  };
  public payPalConfig?: IPayPalConfig;
  isDisableGetAddress = true;
  isHide = false;
  isCreditCard = false;
  isPaypal = false;
  isExpress: boolean = false;
  token;
  isFinish = false;
  addCreditCardShow = false;
  loggedUser;
  userID;
  userDetails;
  step = 1;
  allCountries;
  countryTo;
  countryFrom;
  weight = 1;
  weightUnit = 'kg';
  width = 1;
  height = 1;
  length = 1;
  dimensionUnit = 'cm';
  valueOfItems = 0;
  itemLink;
  isPaymentValidation = null;
  priceText;
  isLoading;
  priceError;
  priceErrorText;
  paramMemberID;
  countryCode;
  memberDetails;
  hostAdressDetails;
  cardNumber = '';
  cardCVC;
  cardExpireMonth;
  cardExpireYear;
  cardFullName;
  errorMessage;
  errorMessagePaypal;
  is_list;
  elf_auth;
  productLinkNgModel;
  productAmountNgModel;
  form = new UntypedFormGroup({
    shipTo: new UntypedFormControl('AU', Validators.required),
    weight: new UntypedFormControl(1, Validators.required),
    width: new UntypedFormControl(1, Validators.required),
    height: new UntypedFormControl(1, Validators.required),
    length: new UntypedFormControl(1, Validators.required),
    weightUnit: new UntypedFormControl('kg', Validators.required),
    dimensionUnit: new UntypedFormControl('cm', Validators.required),
    valueOfItems: new UntypedFormControl(0, Validators.required),
    valueOfItemsCurrency: new UntypedFormControl('USD', Validators.required),
    itemLink: new UntypedFormControl({ value: '', disabled: false }),
    prohibitedGoodsConfirmation: new UntypedFormControl(
      '',
      Validators.required
    ),
    dimensionMetric: new UntypedFormControl('kg', Validators.required),
    itemAmount: new UntypedFormControl(0),
    promoCode: new UntypedFormControl(''),
  });
  // 2022-12-10 BFM Add Credit Card
  currencyList;
  creditCardForm = new UntypedFormGroup({
    nameOnCard: new UntypedFormControl('', Validators.required),
    cardNumber: new UntypedFormControl('', [
      Validators.required,
      Validators.minLength(15),
      Validators.pattern('^[0-9 ]*'),
    ]),
    validThruMonth: new UntypedFormControl('03', Validators.required),
    validThruYear: new UntypedFormControl('2024', Validators.required),
    securityCode: new UntypedFormControl('', [Validators.required]),
  });
  cardVerifyForm = new UntypedFormGroup({
    otpInput1: new UntypedFormControl('', [
      Validators.required,
      Validators.maxLength(1),
    ]),
    otpInput2: new UntypedFormControl('', [
      Validators.required,
      Validators.maxLength(1),
    ]),
    otpInput3: new UntypedFormControl('', [
      Validators.required,
      Validators.maxLength(1),
    ]),
    otpInput4: new UntypedFormControl('', [
      Validators.required,
      Validators.maxLength(1),
    ]),
  });
  // 2022-12-10 BFM Add Credit Card
  selectedCreditCard;
  userCreditCardData;
  userCreditCardDataArray;
  forViewSelectedCard;
  showAddCardForm = false;
  isThereUnverifiedCreditCard;
  isAddCardModalShown = 0;
  showAddCardStargingModal() {
    if (
      document.getElementById('hiddenAddCardModalOpener') &&
      this.isAddCardModalShown == 0
    ) {
      document.getElementById('hiddenAddCardModalOpener').click();
      return (this.isAddCardModalShown = 1);
    }
  }
  orderLinkPlaceholder =
    'Example: https://www.ebay.com/itm/Original-Silicone-var=564232150986';
  orderLinkInputIsDisabled = true;
  browserIsFirefox: boolean = false;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private route: ActivatedRoute,
    public signUpService: SignupService,
    private toastr: ToastrService,
    private watcherService: WatcherService,
    private router: Router,
    private store: Store<AppState>,
    private _icdcService: InstantCalculatorDisocuntCountdownService,
    private _cdr: ChangeDetectorRef,
    private location: Location,
    private browserDetectService: BrowserDetectService
  ) {
    this.watcherService.getLang().subscribe((lang) => {
      this.lang = lang;
    });
    if (this.browserDetectService.isFirefox()) {
      this.browserIsFirefox = true;
    }
    this.store.select('auth').subscribe((state) => {
      this.token = state.token;
      this.userID = state.user?.id;
    });
    this.store.select('packageOrders').subscribe((state) => {
      if (state.packageOrders) {
        this.orderLinksList = new Set(state.packageOrders);
        this.calculateTotalDeclaredValue();
        if (this.orderLinksList.size > 0) {
          const productUrl =
            this.route.snapshot.queryParamMap.get('product_url');
          let productExists = false;
          this.orderLinksList.forEach((item) => {
            if (item.url === productUrl) {
              productExists = true;
            }
          });
          if (productExists) {
          } else {
            this.productLinkNgModel = productUrl;
          }
          const url = new URL(window.location.href);
          url.searchParams.delete('product_url');
          this.location.replaceState(url.pathname + url.search);
        } else {
          const productUrl =
            this.route.snapshot.queryParamMap.get('product_url');
          this.productLinkNgModel = productUrl;
          const url = new URL(window.location.href);
          url.searchParams.delete('product_url');
          this.location.replaceState(url.pathname + url.search);
        }
      } else {
        const productUrl = this.route.snapshot.queryParamMap.get('product_url');
        this.productLinkNgModel = productUrl;
        const url = new URL(window.location.href);
        url.searchParams.delete('product_url');
        this.location.replaceState(url.pathname + url.search);
      }
    });
    this.route.params.subscribe((params) => {
      // const activeRoute = this.router.url;
      this.countryCode = params['countryCode'].toUpperCase();
      // if(activeRoute.includes('address-details-middleware')){
      //   this.router.navigateByUrl(`//shop-from/${this.countryCode}/getaddress-details?user=new`);
      // }
      this.signUpService
        .getHostMembersByCountryCode(this.countryCode)
        .subscribe({
          next: (hostsResponse) => {
            this.countryFrom = this.countryCode;
            if (this.countryFrom == 'NL' || this.countryFrom == 'nl') {
              if (this.document.getElementById('nlWarningModalTrigger')) {
                this.document.getElementById('nlWarningModalTrigger').click();
              }
            }
          },
          error: (err) => { },
        });
      this.signUpService.getAutoHost(this.token, this.countryCode).subscribe({
        next: (autoHostResponse) => {
          if (autoHostResponse['data'] == null || autoHostResponse['error'] == 'Hosts not found' || autoHostResponse['data']['hosts'].length == 0) {
            return this.router.navigate([
              '/',
              
              'shop-from',
              this.countryFrom
            ]);
          }
          const hostID = autoHostResponse['data']['hosts'][0].host_id;
          this.paramMemberID = hostID;
          this.signUpService
            .getHostAddressByUserID(this.token, hostID)
            .subscribe((data) => {
              this.hostAdressDetails = data['data'][0];
              this.memberDetails = data['data'][0];
            });
        },
        error: (err) => {

          this.router.navigate([
            '/',
            
            'shop-from',
            this.countryFrom
          ]);
        },
      });
    });

    this.signUpService
      .getUserByUserID(this.userID, this.token)
      .subscribe((data) => {
        this.elf_auth = +data['data'].right[0].elf_authorization;
        if (this.is_list == 0 && this.elf_auth == 0) {
          this.router.navigate([
            '/',
            
            'getaddress-host',
            this.paramMemberID,
          ]);
        }
        if (data['data'].payment_methods.length > 0) {
          for (let i = 0; i < data['data'].payment_methods.length; i++) {
            if (
              (data['data'].payment_methods[i].type == 'paypal' &&
                data['data'].payment_methods[i].status == 'VERIFIED') ||
              data['data'].payment_methods[i].status === 1
            ) {
              this.isPaymentValidation = true;
              break;
            } else if (
              data['data'].payment_methods[i].type == 'credit_card' &&
              data['data'].payment_methods[i].status == 3
            ) {
              this.isPaymentValidation = true;
              break;
            } else {
              this.isPaymentValidation = false;
            }
          }
        } else {
          if (data['data']['express_account'].length > 0) {
            this.isPaymentValidation = true;
          } else {
            this.route.queryParams.subscribe((params) => {
              const paymentIntent = params.payment_intent ?? '';
              const paymentIntentClientSecret =
                params.payment_intent_client_secret ?? '';
              const redirectStatus = params.redirect_status ?? '';
              if (redirectStatus && redirectStatus == 'succeeded') {
                this.signUpService
                  .verificationExpress(this.token, {
                    express_pay: 1,
                    payment_intent: paymentIntent,
                  })
                  .subscribe({
                    next: (expressVerificationRes) => {
                      if (
                        expressVerificationRes['result']['status'] == 200 &&
                        expressVerificationRes['result']['message'] == 'success'
                      ) {
                        this.toastr.success(
                          'Thank you for verifying your payment method.',
                          'Success'
                        );
                        this.isPaymentValidation = true;
                      } else {
                        this.toastr.error(
                          expressVerificationRes['result']['message'],
                          'Error'
                        );
                        this.isPaymentValidation = false;
                        this.router.navigate([
                          '/',
                          
                          'shop-from',
                          this.countryCode,
                          'getaddress-details',
                        ]);
                      }
                    },
                    error: (err) => {
                      this.toastr.error('An error occured!', 'Error');
                    },
                  });
              } else {
                this.isPaymentValidation = false;
                this.signUpService
                  .getExpressCheckoutIntent(this.token, {
                    shopper_id: this.userID,
                    express_pay: 1,
                    country_from: this.countryFrom ?? '',
                    country_to: this.form.value.shipTo ?? '',
                    payment_method_type: ['card', 'klarna'],
                  })
                  .subscribe({
                    next: (expressRes) => {
                      if (expressRes['result']['status'] == 200) {
                        const clientSecret =
                          expressRes['data']['client_secret'];
                        const stripe = Stripe(
                          this.signUpService.stripeClientSecret
                        );
                        const appearance = {
                          theme: 'stripe',
                          variables: {
                            borderRadius: '5px',
                          },
                        };
                        const expressCheckoutOptions = {
                          buttonHeight: 50,
                          buttonType: {
                            applePay: 'plain',
                            googlePay: 'plain',
                          },
                          buttonTheme: {
                            applePay: 'black',
                            googlePay: 'white',
                          },
                          paymentMethods: {
                            applePay: 'always',
                            googlePay: 'always',
                          },
                          paymentMethodOrder: [
                            'applePay',
                            'googlePay',
                            'link',
                            'amazonPay',
                          ],
                          layout: {
                            overflow: 'never',
                          },
                        };
                        const elements = stripe.elements({
                          mode: 'payment',
                          amount: 50,
                          currency: 'usd',
                          appearance,
                        });

                        const expressCheckoutElement = elements.create(
                          'expressCheckout',
                          expressCheckoutOptions
                        );
                        expressCheckoutElement.mount(
                          '#express-checkout-element'
                        );

                        expressCheckoutElement.on('click', (event) => {
                          const options = {
                            emailRequired: true,
                          };
                          event.resolve(options);
                        });

                        let stripeHostName = this.signUpService.stripeHostName;

                        const baseUrl = `${stripeHostName}${this.lang}//shop-from/${this.countryCode.toLowerCase()}/getaddress-details`;

                        expressCheckoutElement.on('confirm', function (event) {
                          // call Stripe function to initiate payment confirmation
                          stripe
                            .confirmPayment({
                              elements,
                              clientSecret,
                              confirmParams: {
                                return_url: baseUrl,
                              },
                            })
                            .then(function (result) {
                              if (result.error) {
                                this.toastr.error(
                                  result.error.message,
                                  'Error'
                                );
                              }
                            });
                        });
                      }
                    },
                    error: (expressErr) => {
                      this.toastr.error('An error occured!', 'Error');
                    },
                  });
              }
            });
          }
        }
      });
    this.priceText = 0.0;
    this.signUpService.getAllCountries().subscribe((list) => {
      this.allCountries = list['data'];
    });

    this.signUpService.getUserIPData().subscribe((data) => {
      const countryCode = data['country'] === 'GB' ? 'UK' : data['country'];
      this.form.patchValue({ shipTo: countryCode });
      this.calculatePrice();
    });
    this.signUpService.getCurrencyList(this.token).subscribe((data) => {
      if (data['result']['status'] == 200) {
        this.currencyList = data['data'];
      } else {
        this.toastr.error(data['result']['message'], 'Error');
      }
    });
    // Get User Credit Cards
    this.signUpService.getUserCreditCards(this.token).subscribe((data) => {
      if (data['result']['status'] != 200) {
        this.toastr.error('Error', data['result']['message']);
      } else {
        this.userCreditCardData = data['data'];
        if (this.userCreditCardData?.length > 0) {
          // Listed Cards
          this.userCreditCardDataArray = this.userCreditCardData.filter(
            (creditCard) => {
              return (
                creditCard.list_card == 1 &&
                creditCard.status > 0 &&
                !creditCard.wallet
              );
            }
          );
          // Verified Cards
          const verifiedCreditCard = this.userCreditCardDataArray.filter(
            (creditCard) => {
              return creditCard.status == 3;
            }
          );
          const unVerifiedCreditCard = this.userCreditCardDataArray.filter(
            (creditCard) => {
              return (
                creditCard.status == 1 ||
                (creditCard.status == 2 && creditCard.verification_attempts < 2)
              );
            }
          );

          const verified3dSecureCreditCard =
            this.userCreditCardDataArray.filter((creditCard) => {
              return creditCard.payment_method_id != '';
            });
          if (verified3dSecureCreditCard.length > 0) {
            const lastVerifiedCreditCard = verified3dSecureCreditCard.reduce(
              function (prev, current) {
                return prev.date > current.date ? prev : current;
              }
            );
            this.selectedCreditCard = lastVerifiedCreditCard.id;
            this.forViewSelectedCard = lastVerifiedCreditCard;
          }
          if (
            verified3dSecureCreditCard.length < 1 &&
            verifiedCreditCard.length > 0
          ) {
            const lastVerifiedCreditCard = verifiedCreditCard.reduce(function (
              prev,
              current
            ) {
              return prev.date > current.date ? prev : current;
            });
            this.selectedCreditCard = lastVerifiedCreditCard.id;
            this.forViewSelectedCard = lastVerifiedCreditCard;
          }

          if (
            verified3dSecureCreditCard.length < 1 &&
            verifiedCreditCard.length < 1 &&
            unVerifiedCreditCard.length > 0
          ) {
            this.showAddCardForm = false;
            const lastunVerifiedCreditCard = unVerifiedCreditCard.reduce(
              function (prev, current) {
                return prev.date > current.date ? prev : current;
              }
            );
            this.selectedCreditCard = lastunVerifiedCreditCard.id;
            this.forViewSelectedCard = lastunVerifiedCreditCard;
            this.isThereUnverifiedCreditCard = true;
          }
        } else {
          this.showAddCardForm = false;
          this.forViewSelectedCard == null;
        }
      }
    });
  }

  mobileExpressCheckoutMounted: boolean = false;

  mountExpressCheckout() {
    if (this.mobileExpressCheckoutMounted) return;
    this.signUpService
      .getExpressCheckoutIntent(this.token, {
        shopper_id: this.userID,
        express_pay: 1,
        country_from: this.countryFrom ?? '',
        country_to: this.form.value.shipTo ?? '',
        payment_method_type: ['card', 'klarna'],
      })
      .subscribe({
        next: (expressRes) => {
          if (expressRes['result']['status'] == 200) {
            const clientSecret = expressRes['data']['client_secret'];
            const stripe = Stripe(this.signUpService.stripeClientSecret);
            const appearance = {
              theme: 'stripe',
              variables: {
                borderRadius: '5px',
              },
            };
            const expressCheckoutOptions = {
              buttonHeight: 50,
              buttonType: {
                applePay: 'plain',
                googlePay: 'plain',
              },
              buttonTheme: {
                applePay: 'black',
                googlePay: 'white',
              },
              paymentMethods: {
                applePay: 'always',
                googlePay: 'always',
              },
              paymentMethodOrder: [
                'applePay',
                'googlePay',
                'link',
                'amazonPay',
              ],
              layout: {
                overflow: 'never',
              },
            };
            const elements = stripe.elements({
              mode: 'payment',
              amount: 50,
              currency: 'usd',
              appearance,
            });

            const expressCheckoutElement = elements.create(
              'expressCheckout',
              expressCheckoutOptions
            );
            expressCheckoutElement.mount('#express-checkout-element-mobile');
            this.mobileExpressCheckoutMounted = true;

            expressCheckoutElement.on('click', (event) => {
              const options = {
                emailRequired: true,
              };
              event.resolve(options);
            });

            let stripeHostName = this.signUpService.stripeHostName;

            const baseUrl = `${stripeHostName}${this.lang}//shop-from/${this.countryCode.toLowerCase()}/getaddress-details`;

            expressCheckoutElement.on('confirm', function (event) {
              // call Stripe function to initiate payment confirmation
              stripe
                .confirmPayment({
                  elements,
                  clientSecret,
                  confirmParams: {
                    return_url: baseUrl,
                  },
                })
                .then(function (result) {
                  if (result.error) {
                    this.toastr.error(result.error.message, 'Error');
                  }
                });
            });
          }
        },
        error: (expressErr) => {
          this.toastr.error('An error occured!', 'Error');
        },
      });
  }
  changePlaceHolder() {
    if (this.form.controls.prohibitedGoodsConfirmation.value == true) {
      // this.orderLinkPlaceholder = 'Example: https://www.ebay.com/itm/Original-Silicone-var=564232150986';
      // this.form.controls.itemLink.enable();
    } else {
    }
  }
  scrollintoview(element, paymentMethodFixer = false) {
    let el = window.document.getElementById(element);
    if (paymentMethodFixer == true) {
      window.document.getElementById('addCardSectionButton').click();
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'center',
      });
    } else {
      const elementRect = el.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      const middle = absoluteElementTop - window.innerHeight / 2;
      window.scrollTo(0, middle);
      // el.getBoundingClientRect();
      // el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    }
  }
  payPalErrorMessage;
  isShowCardFront = true;
  changeCardFlip(flipType) {
    if (flipType == 'back') {
      this.isShowCardFront = false;
    } else if (flipType == 'front') {
      this.isShowCardFront = true;
    }
  }
  checkCreditCardInputValidations() {
    let hasError = false;
    if (this.creditCardForm.controls.nameOnCard.status == 'INVALID') {
      this.creditCardForm.controls.nameOnCard.markAsTouched();
      hasError = true;
    }
    if (this.creditCardForm.controls.cardNumber.status == 'INVALID') {
      this.creditCardForm.controls.cardNumber.markAsTouched();
      hasError = true;
    }
    if (this.creditCardForm.controls.validThruMonth.status == 'INVALID') {
      this.creditCardForm.controls.validThruMonth.markAsTouched();
      hasError = true;
    }
    if (this.creditCardForm.controls.validThruYear.status == 'INVALID') {
      this.creditCardForm.controls.validThruYear.markAsTouched();
      hasError = true;
    }
    if (this.creditCardForm.controls.securityCode.status == 'INVALID') {
      this.creditCardForm.controls.securityCode.markAsTouched();
      hasError = true;
    }
    return hasError;
  }
  checkInputValidationsVerify() {
    let hasError = false;

    if (this.cardVerifyForm.controls.otpInput1.status == 'INVALID') {
      this.cardVerifyForm.controls.otpInput1.markAsTouched();
      hasError = true;
    }
    if (this.cardVerifyForm.controls.otpInput2.status == 'INVALID') {
      this.cardVerifyForm.controls.otpInput2.markAsTouched();
      hasError = true;
    }
    if (this.cardVerifyForm.controls.otpInput3.status == 'INVALID') {
      this.cardVerifyForm.controls.otpInput3.markAsTouched();
      hasError = true;
    }
    if (this.cardVerifyForm.controls.otpInput4.status == 'INVALID') {
      this.cardVerifyForm.controls.otpInput4.markAsTouched();
      hasError = true;
    }
    return hasError;
  }
  addNewCard() {
    // Check User Session

    if (this.checkCreditCardInputValidations() == false) {
      this.isLoading = true;
      let userData = {
        cc: {
          card_number: this.creditCardForm.value.cardNumber,
          cvc: this.creditCardForm.value.securityCode,
          exp_month: this.creditCardForm.value.validThruMonth,
          exp_year: this.creditCardForm.value.validThruYear,
          name: this.creditCardForm.value.nameOnCard,
        },
      };
      this.signUpService
        .AddCreditCard(this.token, userData)
        .subscribe((data) => {
          if (data['result']['status'] == 200) {
            this.toastr.success(data['result']['message'], 'Success');
            this.userCreditCardData = data['data'];
            this.userCreditCardDataArray = this.userCreditCardData.filter(
              (creditCard) => {
                return creditCard.list_card == 1 && creditCard.status > 0;
              }
            );
            this.showAddCardForm = false;
            this.creditCardForm.reset({
              validThruMonth: '10',
              validThruYear: '2022',
            });

            if (this.userCreditCardDataArray.length > 1) {
              const lastAddedCreditCard = this.userCreditCardDataArray.reduce(
                function (prev, current) {
                  return prev.date > current.date ? prev : current;
                }
              );
              this.selectedCreditCard = lastAddedCreditCard.id;
              this.forViewSelectedCard = lastAddedCreditCard;
            } else if (this.userCreditCardDataArray.length == 1) {
              const lastAddedCreditCard = this.userCreditCardDataArray[0];
              if (lastAddedCreditCard) {
                this.selectedCreditCard = lastAddedCreditCard.id;
                this.forViewSelectedCard = lastAddedCreditCard;
              }
              this.isLoading = false;
              this.showAddCardForm = false;
            } else {
              this.isLoading = false;
            }
            this.isThereUnverifiedCreditCard = true;
            this.isLoading = false;
          } else {
            if (
              data['result']['message'] ==
              'Your card was declined. This transaction requires authentication.'
            ) {
              this.toastr.warning(
                'This card requires authentication. Please Pay With 3D Secure ',
                'Warning',
                { timeOut: 10000 }
              );
              this.showAddCardForm = false;
              this.isLoading = false;
            } else {
              this.toastr.error(data['result']['message'], 'Error');
              this.isLoading = false;
            }
          }
          this.isLoading = false;
        });
      this.isLoading = false;
    }
  }
  //Delete Credit Card
  deleteCreditCard(creditCard) {
    let userData = {
      card_id: creditCard.id,
    };
    this.signUpService
      .deleteCreditCard(this.token, userData)
      .subscribe((data) => {
        if (data['result']['status'] == 200) {
          this.toastr.success(data['result']['message'], 'Success');
          this.userCreditCardData = data['data'];
          this.userCreditCardDataArray = this.userCreditCardData.filter(
            (creditCard) => {
              return creditCard.list_card == 1;
            }
          );

          if (this.userCreditCardDataArray.length > 0) {
            const lastAddedCreditCard = this.userCreditCardDataArray.reduce(
              function (prev, current) {
                return prev.date > current.date ? prev : current;
              }
            );
            this.forViewSelectedCard = lastAddedCreditCard;
            this.selectedCreditCard = '';
          } else {
            this.forViewSelectedCard = null;
          }
        } else {
          this.toastr.error(data['result']['message'], 'Error');
        }
      });
  }
  // Delete Credit Card
  // Verify
  startCardVerifyStatusZero(creditCard) {
    let userData = {
      stripe_customer_id: creditCard.customer,
    };
    this.signUpService
      .verifyCreditCardWithHasError(this.token, userData)
      .subscribe((data) => {
        if (data['result']['status'] == 200) {
          this.toastr.success(data['result']['message'], 'Success');
          location.reload();
        } else {
          this.toastr.error(data['result']['message'], 'Error');
        }
      });
  }
  startCardVerifyStatusOne(creditCard) {
    if (this.checkInputValidationsVerify() == false) {
      this.isLoading = true;
      let userData = {
        client_amount: `${this.cardVerifyForm.value.otpInput1}${this.cardVerifyForm.value.otpInput2}${this.cardVerifyForm.value.otpInput3}${this.cardVerifyForm.value.otpInput4}`,
        id: creditCard.id,
      };
      this.signUpService
        .verifyCreditCardWithStatusOne(this.token, userData)
        .subscribe((data) => {
          if (data['result']['status'] == 200) {
            this.toastr.success(data['result']['message'], 'Success');
            this.userCreditCardData = data['data'];
            this.userCreditCardDataArray = this.userCreditCardData.filter(
              (creditCard) => {
                return creditCard.list_card == 1;
              }
            );
            this.cardVerifyForm.reset({
              currency: 'USD',
            });
            const lastConfirmedCreditCard = this.userCreditCardDataArray.reduce(
              function (prev, current) {
                return prev.date > current.date ? prev : current;
              }
            );
            this.isThereUnverifiedCreditCard = false;
            this.forViewSelectedCard = lastConfirmedCreditCard;
            this.selectedCreditCard = lastConfirmedCreditCard.id;
            this.isPaymentValidation = true;
          } else {
            this.cardVerifyForm.reset({
              currency: 'USD',
            });
            this.toastr.error(data['result']['message'], 'Error');
            this.signUpService
              .getUserCreditCards(this.token)
              .subscribe((data) => {
                if (data['result']['status'] != 200) {
                  this.toastr.error('Error', data['result']['message']);
                } else {
                  this.userCreditCardData = data['data'];
                  this.userCreditCardDataArray = this.userCreditCardData.filter(
                    (creditCard) => {
                      return creditCard.list_card == 1;
                    }
                  );
                  const lastAddedCreditCard =
                    this.userCreditCardDataArray.reduce(function (
                      prev,
                      current
                    ) {
                      return prev.date > current.date ? prev : current;
                    });
                  this.forViewSelectedCard = lastAddedCreditCard;
                  this.selectedCreditCard = lastAddedCreditCard.id;
                }
              });
          }
          this.isLoading = false;
        });
    } else {
      this.toastr.error('Verify Form Has Error');
      this.cardVerifyForm.reset({
        otpInput1: '',
        otpInput2: '',
        otpInput3: '',
        otpInput4: '',
      });
    }
  }
  // Verify
  checkUserPaymentValidation(paymentMethods) {
    for (var i = paymentMethods.length; (i = 0); i++) {
      if (
        paymentMethods[i].type == 'paypal' &&
        paymentMethods[i].status == 'VERIFIED'
      ) {
        i = paymentMethods.length;
        return true;
      } else if (
        (paymentMethods[i].type == 'credit_card' &&
          paymentMethods[i].status == 1) ||
        (paymentMethods[i].type == 'credit_card' &&
          paymentMethods[i].status == 2) ||
        (paymentMethods[i].type == 'credit_card' &&
          paymentMethods[i].status == 3)
      ) {
        i = paymentMethods.length;
        return true;
      } else {
        return false;
      }
    }
  }
  lang;
  remainingTime;
  private localStorageKey = 'countdown_timer';
  ngOnInit(): void {

    this.initConfig();
    this.form.controls.itemLink.markAsTouched();

    this.form.controls.prohibitedGoodsConfirmation.valueChanges.subscribe(
      () => {
        this.changePlaceHolder();
      }
    );

    this._icdcService.getTimerStartSignal().subscribe((start) => {
      this.timerStart = start;
    });

    this.isThereADiscount = false;
    this._icdcService.getRemainingTime().subscribe((time) => {
      this.remainingTime = time;
      if (this.remainingTime.minutes > 0 || this.remainingTime.seconds > 0) {
        this.isThereADiscount = true;
      } else if (
        time.minutes === 0 &&
        time.seconds === 0 &&
        this.isThereADiscount === true
      ) {
        this.isThereADiscount = false;
        // this.calculatePrice();
      }
    });

    this._icdcService.getTimerFinishedSignal().subscribe((finished) => {
      const stateString = JSON.parse(
        localStorage.getItem(this.localStorageKey)
      );
      this.timerFinished = finished;

      if (this.timerFinished === true && stateString.shown) {
        this.calculatePrice();
        this.isThereADiscount = false;
      }
    });
  }
  ngAfterViewInit() {
    //this.isHide = this.child.isHide;
    this.signUpService
      .getUserByUserID(this.userID, this.token)
      .subscribe((data) => {
        this.loggedUser = data['data'];
      });
  }
  addNewPaypal(response) {
    document.getElementById('payPalVerificationModalButton').click();
    this.isLoading = true;
    var userData = {
      paypal: response,
    };
    this.signUpService
      .verificationPaypal(this.token, userData)
      .subscribe((data) => {
        if (data['result']['status'] == 200) {
          if (
            data['data'].payer.status == 'VERIFIED' ||
            data['data'].payer.status == 'Non-US Verified'
          ) {
            this.isPaymentValidation = true;
            this.toastr.success(
              'Your PayPal account has been verified',
              'Success'
            );
            this.errorMessagePaypal = '';
            document.getElementById('paypalVerificationModalCloser').click();
          } else {
            this.toastr.error(
              'Your Paypal account is not verified. Please use a different payment method.',
              'Error'
            );
            this.errorMessagePaypal =
              'Your Paypal account is not verified. Please use a different payment method.';
          }
          this.isLoading = false;
        } else {
          this.errorMessagePaypal =
            data['result']['message'] +
            ' Please use a different payment method';
          this.toastr.error(
            data['result']['message'] +
            ' Please use a different payment method',
            'Error'
          );
          this.isLoading = false;
        }
      });
  }
  private initConfig(): void {
    this.payPalConfig = {
      currency: 'USD',
      clientId: this.signUpService.paypalClientID,
      createOrderOnClient: (data) =>
        <ICreateOrderRequest>{
          intent: 'CAPTURE',
          purchase_units: [
            {
              amount: {
                currency_code: 'USD',
                value: '0.50',
                breakdown: {
                  item_total: {
                    currency_code: 'USD',
                    value: '0.50',
                  },
                },
              },
              description: this.memberDetails.id.toString(),
            },
          ],
        },
      advanced: {
        commit: 'true',
        extraQueryParams: [{ name: 'disable-funding', value: 'credit,card' }],
      },
      style: {
        label: 'paypal',
        layout: 'vertical',
        color: 'blue',
        height: 42,
      },
      onApprove: (data, actions) => {
        return actions.order.capture().then((response) => {
          this.addNewPaypal(response);
        });
      },
      onClientAuthorization: (data) => {
        //this.showSuccess = true;
      },
      onCancel: (data, actions) => {
        //this.showCancel = true;
      },
      onError: (err) => {
        //this.showError = true;
      },
      onClick: (data, actions) => { },
    };
  }
  checkCardAdded($event) {
    //this.isHide = $event;
  }
  checkInputValidations() {
    var hasError = false;

    if (this.form.controls.shipTo.status == 'INVALID') {
      this.form.controls.shipTo.markAsTouched();
      hasError = true;
    }

    if (this.form.controls.weight.status == 'INVALID') {
      this.form.controls.weight.markAsTouched();
      hasError = true;
    }

    if (this.form.controls.width.status == 'INVALID') {
      this.form.controls.width.markAsTouched();
      hasError = true;
    }

    if (this.form.controls.height.status == 'INVALID') {
      this.form.controls.height.markAsTouched();
      hasError = true;
    }

    if (this.form.controls.length.status == 'INVALID') {
      this.form.controls.length.markAsTouched();
      hasError = true;
    }

    if (this.form.controls.valueOfItems.status == 'INVALID') {
      this.form.controls.valueOfItems.markAsTouched();
      hasError = true;
    }

    if (this.orderLinksList.size === 0) {
      this.form.controls.itemLink.markAsTouched();
      this.toastr.error('Please add at least one item link', 'Error');
      hasError = true;
    }
    if (this.form.controls.prohibitedGoodsConfirmation.status == 'INVALID') {
      this.form.controls.prohibitedGoodsConfirmation.markAsTouched();
      hasError = true;
    }

    return hasError;
  }
  checkValidationsCalculatePrice() {
    var hasError = false;

    if (this.form.controls.shipTo.status == 'INVALID') {
      this.form.controls.shipTo.markAsTouched();
      hasError = true;
    }

    if (this.form.controls.weight.status == 'INVALID') {
      this.form.controls.weight.markAsTouched();
      hasError = true;
    }

    if (this.form.controls.width.status == 'INVALID') {
      this.form.controls.width.markAsTouched();
      hasError = true;
    }

    if (this.form.controls.height.status == 'INVALID') {
      this.form.controls.height.markAsTouched();
      hasError = true;
    }

    if (this.form.controls.length.status == 'INVALID') {
      this.form.controls.length.markAsTouched();
      hasError = true;
    }

    if (this.form.controls.valueOfItems.status == 'INVALID') {
      this.form.controls.valueOfItems.markAsTouched();
      hasError = true;
    }

    return hasError;
  }
  oldPriceText;
  calculatePrice(isCheckCodeAc = false) {
    if (!this.countryFrom) {
      return;
    }

    if (isCheckCodeAc == true) {
      if (
        this.form.value.promoCode == '' ||
        this.form.value.promoCode == undefined ||
        this.form.value.promoCode == null ||
        this.form.value.promoCode.length < 6
      ) {
        return this.toastr.error('Please enter a valid discount code', 'Error');
      }
    }

    if (this.checkValidationsCalculatePrice() == false) {
      this.isLoading = true;
      this.priceText = 0.0;
      this.oldPriceText = 0.0;
      let amountArray = [];

      let discountCode = 'INSTANT10';
      var payload;

      let { started, finished, shown } = this._icdcService.getTimerStatus();
      const stateString = JSON.parse(
        localStorage.getItem(this.localStorageKey)
      );
      if (this.isThereADiscount === true && !finished && stateString) {
        this.calculatePriceWithDiscount();
      } else {
        payload = {
          country_to: this.form.value.shipTo,
          country_from: this.countryFrom?.toUpperCase(),
          dimension: {
            weight: this.form.value.weight ?? 0,
            weight_unit: this.form.value.weightUnit,
            height: this.form.value.height ?? 0,
            width: this.form.value.width ?? 0,
            length: this.form.value.length ?? 0,
            dimension_unit: this.form.value.dimensionUnit,
          },
          shopper_id: this.paramMemberID,
        };

        this.signUpService
          .calculatePricing(
            this.token,
            this.form.value.shipTo,
            this.countryFrom?.toUpperCase(),
            this.form.value.weight ?? 0,
            this.form.value.weightUnit,
            this.form.value.height ?? 0,
            this.form.value.width ?? 0,
            this.form.value.length ?? 0,
            this.form.value.dimensionUnit,
            this.paramMemberID,
            this.form.value.promoCode
          )
          .subscribe((data) => {
            if (data['result']['status'] != 200) {
              this.toastr.error(data['result']['message'], 'Error');
              this.errorMessage = data['result']['message'];
              this.isLoading = false;
              this.isDisableGetAddress = true;
              if (
                this.form.value.promoCode &&
                this.form.value.promoCode.length >= 6 &&
                data['result']['status'] === 642
              ) {
                this.form.get('promoCode').setValue('');
                this.calculatePrice();
              }
            } else {
              this.errorMessage = '';
              amountArray = data['data']['shipment_amount'].map(
                (item) => item['shipment_amount_after_discount']
              );
              const minValue = Math.min(...amountArray);
              const minIndex = amountArray.indexOf(minValue);
              const minItem = data['data']['shipment_amount'][minIndex];
              this.priceText = minValue;
              this.isLoading = false;
              this.isDisableGetAddress = false;
              if (
                this.form.value.promoCode &&
                this.form.value.promoCode.length >= 6
              ) {
                this.isThereADiscount = true;
                this.oldPriceText =
                  data['data']['shipment_amount'][minIndex][
                  'total_shipment_amount'
                  ];
              }
              if (this.countryFrom == 'US' && this.form.value.shipTo == 'IR') {
                this.isDisableGetAddress = true;
                this.errorMessage =
                  'Shipment between the chosen countries is not possible.';
                this.priceText = 0.0;
              }

              if (
                data['result']['status'] === 200 &&
                data['result']['message'] == 'Loyalty Discount used'
              ) {
                this.toastr.success('Loyalty Discount used');
                this.isThereADiscount = true;
                this.oldPriceText =
                  data['data']['shipment_amount'][minIndex][
                  'total_shipment_amount'
                  ];
              }
              this._cdr.detectChanges();
            }
          });
      }
    }
  }
  calculatePriceWithDiscount() {
    let discountCode = 'INSTANT10';
    let payload;

    this.priceText = 0.0;
    this.oldPriceText = 0.0;
    var amountArray = [];

    let { started, finished } = this._icdcService.getTimerStatus();

    payload = {
      country_to: this.form.value.shipTo,
      country_from: this.countryFrom?.toUpperCase(),
      dimension: {
        weight: this.form.value.weight ?? 0,
        weight_unit: this.form.value.weightUnit,
        height: this.form.value.height ?? 0,
        width: this.form.value.width ?? 0,
        length: this.form.value.length ?? 0,
        dimension_unit: this.form.value.dimensionUnit,
      },
      shopper_id: '',
      promo_code: discountCode,
    };
    this.signUpService
      .calculatePricingWithDiscount('', payload)
      .subscribe((data) => {
        if (data['result']['status'] != 200) {
          this.priceError = true;
          this.priceErrorText = data['result']['message'];
          this.toastr.error(data['result']['message'], 'Error');
          this.isLoading = false;

          // Temp
          this.isThereADiscount = true;
          this._icdcService.startCountdown();
        } else {
          this.isLoading = false;
          this.isDisableGetAddress = false;
          if (data['data']['shipment_amount']?.length > 0) {
            this.isThereADiscount = true;
            this._icdcService.startCountdown();
          }
          for (
            let index = 0;
            index < data['data']['shipment_amount']?.length;
            index++
          ) {
            amountArray.push(
              data['data']['shipment_amount'][index][
              'shipment_amount_after_discount'
              ]
            );
          }
          if (amountArray.length > 0) {
            this.oldPriceText =
              +data['data']['shipment_amount'][0]['total_shipment_amount'];
            this.priceText = Math.min.apply(Math, amountArray);
          } else {
            this.priceText = 0;
            this.oldPriceText = 0;
          }
          this.isLoading = false;
          this.priceError = false;
        }
      });
  }
  changeDimensionsUnit(val) {
    if (val === 'kg') {
      this.form.controls.dimensionMetric.setValue('kg');
      this.form.controls.weightUnit.setValue('kg');
      this.form.controls.dimensionUnit.setValue('cm');
      this.calculatePrice();
    } else {
      this.form.controls.dimensionMetric.setValue('lbs');
      this.form.controls.weightUnit.setValue('lbs');
      this.form.controls.dimensionUnit.setValue('inch');
      this.calculatePrice();
    }
  }
  paymentValidationNeeded = false;
  scrollToPaymentValidationArea() {
    this.paymentValidationNeeded = true;
    const paymentValdiationArea = this.document.getElementById(
      'paymentValidationArea'
    );
    const paymentValidationAreaMobile = this.document.getElementById(
      'paymentValidationAreaMobile'
    );
    let windowSize = window.innerWidth;
    if (windowSize < 768) {
      paymentValidationAreaMobile.scrollIntoView();
    } else {
      paymentValdiationArea.scrollIntoView();
    }
  }
  scrollToProhibitedItemsArea() {
    const prohibitedItemsArea = this.document.getElementById(
      'prohibitedItemsArea'
    );
    prohibitedItemsArea.scrollIntoView();
  }
  productNeeded = false;
  scrollToAddProductArea() {
    this.productNeeded = true;
    const addProductArea = this.document.getElementById('addProductArea');
    addProductArea.scrollIntoView();
  }
  getAddress() {
    let conditions =
      'isDisableGetAddress || !isPaymentValidation || orderLinksList?.size === 0 || !form.value.prohibitedGoodsConfirmation';
    if (this.isPaymentValidation == false) {
      this.toastr.error('Please complete payment validation.', 'Error');
      this.scrollToPaymentValidationArea();
      return;
    }
    if (this.orderLinksList.size === 0) {
      this.toastr.error('Please add at least 1 product.', 'Error');
      this.scrollToAddProductArea();
      return;
    }
    if (this.form.value.prohibitedGoodsConfirmation == false) {
      this.toastr.error(
        'Please confirm that you will not be shipping any prohibited items.',
        'Error'
      );
      this.scrollToProhibitedItemsArea();
      return;
    }
    if (this.countryFrom == 'US' && this.form.value.shipTo == 'IR') {
      this.toastr.error(
        'Shipment between the chosen countries is not possible.',
        'Error'
      );
      return;
    }
    if (!this.form.value.shipTo) {
      this.toastr.error('Please select destination country.', 'Error');
      return;
    }
    var userData = {};
    userData = {
      shopper_id: this.userID,
      country_from: this.countryFrom?.toUpperCase(),
      country_to: this.form.value.shipTo,
      dimension_expected: {
        dimension_unit: this.form.value.dimensionUnit,
        height: this.form.value.height ?? 0,
        length: this.form.value.length ?? 0,
        weight: this.form.value.weight ?? 0,
        width: this.form.value.width ?? 0,
        weight_unit: this.form.value.weightUnit,
      },
      host_id: this.paramMemberID,
      invoice_expected: {
        amount: this.totalDeclaredValueAmount ?? 0,
        currency: this.form.value.valueOfItemsCurrency,
      },
      prepromo_code: this.form.value.promoCode,
    };
    let productUrls = [];
    this.orderLinksList.forEach((product) => {
      productUrls.push(product);
    });

    productUrls.forEach((url, index) => {
      userData[`product_link_${index + 1}`] = productUrls[index];
    });

    if (this.checkInputValidations() == false) {
      this.isDisableGetAddress = true;
      this.isLoading = true;
      let { started, finished } = this._icdcService.getTimerStatus();
      if (started && !finished) {
        userData['instant_calculator_discount'] = {
          discount_code: 'INSTANT10',
          apply_code: 1,
        };
      } else if (started && finished) {
        userData['instant_calculator_discount'] = {
          discount_code: 'INSTANT10',
          apply_code: 0,
        };
      } else {
        userData['instant_calculator_discount'] = {};
      }
      this.signUpService
        .getAddressOrder(this.token, userData)
        .subscribe((data) => {
          if (data['result']['status'] == 200) {
            sessionStorage.setItem('getaddress', JSON.stringify(data['data']));
            this.toastr.success(data['result']['message'], 'Success');
            this.store.dispatch(PackageOrdersAction.DeletePackageOrderList());
            localStorage.setItem('lastCreadtedOrderID', data['data'].id);
            localStorage.setItem('GetAddress', data['data'].shopper.email);
            this.router.navigate([
              '/',
              
              'host',
              'getaddress-success',
            ]);
            this.isLoading = false;
            this.isDisableGetAddress = false;
            //this.form.reset()
          } else {
            this.isLoading = false;
            this.isDisableGetAddress = false;
            this.toastr.error(data['result']['message'], 'Error');
          }
        });
    }
  }
  addCreditCard() {
    if (
      this.cardNumber.toString().length < 16 ||
      !this.cardFullName ||
      !this.cardExpireMonth ||
      !this.cardExpireYear ||
      !this.cardCVC
    ) {
      if (this.cardNumber.toString().length < 16) {
        this.toastr.error('Error', '16 hane!');
      }
      if (!this.cardFullName) {
        this.toastr.error('Error', 'Full Name!');
      }
      if (!this.cardExpireMonth) {
        this.toastr.error('Error', 'Month!');
      }
      if (!this.cardExpireYear) {
        this.toastr.error('Error', 'Year!');
      }
      if (!this.cardCVC) {
        this.toastr.error('Error', 'CVC!');
      }
    } else {
      this.isLoading = true;
      // this.signUpService.AddCreditCard(this.token, this.cardNumber, this.cardCVC, this.cardExpireMonth, this.cardExpireYear, this.cardFullName).subscribe(data => {
      //   ;
      //   if (data["result"]["status"] != 200) {
      //     this.toastr.error('Error', data["result"]["message"]);
      //   }
      //   else {
      //     this.toastr.success('Done!', 'Your credit card add!')
      //     this.isPaymentValidation = true;
      //   }
      //   this.isLoading = false;

      // })
    }
  }
  // Order OG
  getOrderOGDetails(ev) {
    let pastedText = ev.target.value;

    this.signUpService.getOrderDetailFromOG(pastedText).subscribe(
      (details) => {
        if (
          !this.isUrl(details.image) ||
          details.image == null ||
          details.image == '' ||
          details.image == undefined
        ) {
          details.image = '/assets/img/no-product-image.png';
        }

        this.orderOGDetails = details;
      },
      (err) => {
        this.orderOGDetails = {
          scrape: false,
          description: '',
          title: '',
          _url: pastedText,
          url: pastedText,
          image: '/assets/img/no-product-image.png',
          type: '',
          site_name: '',
        };
      }
    );
  }

  isUrl = (string: string) => {
    const urlPattern = new RegExp(
      '^(https?:\\/\\/)?' +
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
      '((\\d{1,3}\\.){3}\\d{1,3}))' +
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
      '(\\?[;&a-z\\d%_.~+=-]*)?' +
      '(\\#[-a-z\\d_]*)?$',
      'i'
    );
    return !!urlPattern.test(string);
  };

  // SHPN-5343
  onKeyPresOTP(event, index) {
    let input1 = document.getElementById('otpInput1') as HTMLInputElement;
    let input2 = document.getElementById('otpInput2') as HTMLInputElement;
    let input3 = document.getElementById('otpInput3') as HTMLInputElement;
    let input4 = document.getElementById('otpInput4') as HTMLInputElement;

    if (event.key == 'Backspace') {
      switch (index) {
        case 1:
          this.cardVerifyForm.controls.otpInput1.setValue('');
          input1.focus();
          break;
        case 2:
          this.cardVerifyForm.controls.otpInput2.setValue('');
          input1.focus();
          break;
        case 3:
          this.cardVerifyForm.controls.otpInput3.setValue('');
          input2.focus();
          break;
        case 4:
          this.cardVerifyForm.controls.otpInput4.setValue('');
          input3.focus();
          break;
        default:
          break;
      }
    } else if (event.which < 48 || event.which > 90) {
      return;
    } else {
      switch (index) {
        case 1:
          if (!event.code.includes('Digit')) {
            this.cardVerifyForm.controls.otpInput1.setValue('');
          } else {
            this.cardVerifyForm.controls.otpInput1.setValue(event.key);
            this.cardVerifyForm.controls.otpInput1.value
              ? input2.focus()
              : input1.focus();
          }

          break;
        case 2:
          if (!event.code.includes('Digit')) {
            this.cardVerifyForm.controls.otpInput2.setValue('');
          } else {
            this.cardVerifyForm.controls.otpInput2.setValue(event.key);
            this.cardVerifyForm.controls.otpInput2.value
              ? input3.focus()
              : input2.focus();
          }
          break;
        case 3:
          if (!event.code.includes('Digit')) {
            this.cardVerifyForm.controls.otpInput3.setValue('');
          } else {
            this.cardVerifyForm.controls.otpInput3.setValue(event.key);
            this.cardVerifyForm.controls.otpInput3.value
              ? input4.focus()
              : input3.focus();
          }
          break;
        case 4:
          if (!event.code.includes('Digit')) {
            this.cardVerifyForm.controls.otpInput4.setValue('');
          } else {
            this.cardVerifyForm.controls.otpInput4.setValue(event.key);
            this.cardVerifyForm.controls.otpInput4.value
              ? input4.blur()
              : input4.focus();
          }
          break;
        default:
          break;
      }
    }
  }
  showAddCardModal() {
    return document.getElementById('hiddenAddCardModalOpener').click();
  }
  totalDeclaredValueAmount = 0.0;
  calculateTotalDeclaredValue() {
    this.totalDeclaredValueAmount = 0;

    this.orderLinksList.forEach((product) => {
      this.totalDeclaredValueAmount += parseFloat(product.amount);
    });
  }
  scrollToLastAddedProduct(previousScrollHeight) {
    const items = document.querySelectorAll('.order-links-list-item');
    if (items && items.length > 1) {
      const lastChild = document.querySelector('.order-links-list-item')
        .lastChild as HTMLElement;
      const parentElement = this.document.querySelector(
        '.order-links-list-wrapper'
      ) as HTMLElement;

      if (!lastChild) return;
      requestAnimationFrame(() => {
        parentElement.scrollTop = parentElement.scrollHeight;
      });
    }
    return;
  }

  addProductLink() {
    if (
      parseFloat(this.productAmountNgModel) <= 0 ||
      isNaN(parseFloat(this.productAmountNgModel)) ||
      parseFloat(this.productAmountNgModel) == null ||
      parseFloat(this.productAmountNgModel) == undefined
    )
      return this.toastr.error('Please enter a valid amount', 'Error');

    if (this.orderLinksList.size == 10)
      return this.toastr.error('You can add only 10 products', 'Error');
    if (!this.productLinkNgModel)
      return this.toastr.error('Please enter the link of item', 'Error');
    if (!this.productAmountNgModel)
      return this.toastr.error('Please enter the value of item', 'Error');
    const link = this.productLinkNgModel;
    if (!this.checkUrl(link)) {
      this.productLinkNgModel = '';
      this.productAmountNgModel = 0.0;
      return this.toastr.error(
        'You need to create another order for multiple websites',
        'Error'
      );
    }
    const productAmount = this.productAmountNgModel;
    if (this.orderLinksList.size === 0) {
      this.signUpService.getOrderDetailFromOG(link).subscribe({
        next: (details) => {
          if (
            !this.isUrl(details.image) ||
            details.image == null ||
            details.image == '' ||
            details.image == undefined
          ) {
            details.image = '/assets/img/no-product-image.png';
          }
          const product = {
            image: details?.image ?? '/assets/img/no-product-image.png',
            url: link,
            name: details?.title,
            amount: productAmount,
          };
          this.orderLinksList.add(product);
          this.store.dispatch(
            PackageOrdersAction.UpdatePackageOrderList({
              packageOrdersList: [...this.orderLinksList],
            })
          );
          this.form.controls.itemLink.setValue('');
          this.calculateTotalDeclaredValue();
          this.toastr.success('Product added successfully', 'Success');
          const parentElement = this.document.querySelector(
            '.order-links-list-wrapper'
          ) as HTMLElement;
          var previousScrollHeight = parentElement.scrollHeight;
          this.scrollToLastAddedProduct(previousScrollHeight);
        },
        error: (err) => {
          const product = {
            image: '/assets/img/no-product-image.png',
            url: link,
            name: '',
            amount: productAmount,
          };
          this.orderLinksList.add(product);
          this.store.dispatch(
            PackageOrdersAction.UpdatePackageOrderList({
              packageOrdersList: [...this.orderLinksList],
            })
          );
          this.form.controls.itemLink.setValue('');
          this.calculateTotalDeclaredValue();
          this.toastr.success('Product added successfully', 'Success');
          const parentElement = this.document.querySelector(
            '.order-links-list-wrapper'
          ) as HTMLElement;
          var previousScrollHeight = parentElement.scrollHeight;
          this.scrollToLastAddedProduct(previousScrollHeight);
        },
      });
    } else {
      let isDuplicate = false;
      this.orderLinksList.forEach((item) => {
        if (item.url === link) {
          isDuplicate = true;
          return;
        }
      });
      if (!isDuplicate) {
        this.signUpService.getOrderDetailFromOG(link).subscribe({
          next: (details) => {
            if (
              !this.isUrl(details.image) ||
              details.image == null ||
              details.image == '' ||
              details.image == undefined
            ) {
              details.image = '/assets/img/no-product-image.png';
            }
            const product = {
              image: details?.image ?? '/assets/img/no-product-image.png',
              url: link,
              name: details?.title ? details?.title : '',
              amount: productAmount,
            };
            this.orderLinksList.add(product);
            this.store.dispatch(
              PackageOrdersAction.UpdatePackageOrderList({
                packageOrdersList: [...this.orderLinksList],
              })
            );
            this.form.controls.itemLink.setValue('');
            this.calculateTotalDeclaredValue();
            this.toastr.success('Product added successfully', 'Success');
            const parentElement = this.document.querySelector(
              '.order-links-list-wrapper'
            ) as HTMLElement;
            var previousScrollHeight = parentElement.scrollHeight;
            this.scrollToLastAddedProduct(previousScrollHeight);
          },
          error: (err) => {
            const product = {
              image: '/assets/img/no-product-image.png',
              url: link,
              name: '',
              amount: productAmount,
            };
            this.orderLinksList.add(product);
            this.store.dispatch(
              PackageOrdersAction.UpdatePackageOrderList({
                packageOrdersList: [...this.orderLinksList],
              })
            );
            this.form.controls.itemLink.setValue('');
            this.calculateTotalDeclaredValue();
            this.toastr.success('Product added successfully', 'Success');
            const parentElement = this.document.querySelector(
              '.order-links-list-wrapper'
            ) as HTMLElement;
            var previousScrollHeight = parentElement.scrollHeight;
            this.scrollToLastAddedProduct(previousScrollHeight);
          },
        });
      } else {
        this.toastr.error('Duplicate link', 'Error');
        this.form.controls.itemLink.setValue('');
      }
    }
    this.productLinkNgModel = '';
    this.productAmountNgModel = 0.0;
  }

  selectedProduct;
  selectProduct(product) {
    this.selectedProduct = product;
    this.newProductLink = product?.url;
  }

  deleteProductLink(product) {
    this.orderLinksList.delete(product);
    this.store.dispatch(
      PackageOrdersAction.UpdatePackageOrderList({
        packageOrdersList: [...this.orderLinksList],
      })
    );
    const deleteModalCloser = this.document.getElementById(
      'deleteProductModalCloser'
    );
    this.toastr.success('Product deleted successfully', 'Success');
    if (deleteModalCloser) deleteModalCloser.click();
    this.calculateTotalDeclaredValue();
    if (this.orderLinksList.size == 0) {
      this.availableVendor = '';
    }
  }

  newProductLink;
  editProductLink(product, newUrl) {
    let isNewUrlUnique = true;
    this.orderLinksList.forEach((item) => {
      if (item.url === newUrl) {
        isNewUrlUnique = false;
      }
    });

    if (!isNewUrlUnique) {
      this.toastr.error('New URL already exists in the list', 'Error');
      return;
    }
    if (this.orderLinksList.size > 1) {
      if (!this.checkUrl(newUrl)) {
        return this.toastr.error(
          'You need to create another order for multiple websites',
          'Error'
        );
      }
      return;
    }
    if (this.orderLinksList.size === 1) {
      this.availableVendor = '';
      this.checkUrl(newUrl);
    }
    this.orderLinksList.forEach((item) => {
      if (item.url === product?.url) {
        this.signUpService.getOrderDetailFromOG(newUrl).subscribe({
          next: (details) => {
            if (
              !this.isUrl(details.image) ||
              details.image == null ||
              details.image == '' ||
              details.image == undefined
            ) {
              details.image = '/assets/img/no-product-image.png';
            }

            item.image = details?.image
              ? details?.image
              : '/assets/img/no-product-image.png';
            item.url = newUrl;
            item.name = details?.title ? details?.title : '';
            const editModalCloser = this.document.getElementById(
              'editProductModalCloser'
            );
            this.toastr.success('Product link updated successfully', 'Success');
            this.store.dispatch(
              PackageOrdersAction.UpdatePackageOrderList({
                packageOrdersList: [...this.orderLinksList],
              })
            );
            if (editModalCloser) editModalCloser.click();
          },
          error: (err) => {
            item.image = '/assets/img/no-product-image.png';
            item.url = newUrl;
            item.name = '';
            const editModalCloser = this.document.getElementById(
              'editProductModalCloser'
            );
            this.toastr.success('Product link updated successfully', 'Success');
            this.store.dispatch(
              PackageOrdersAction.UpdatePackageOrderList({
                packageOrdersList: [...this.orderLinksList],
              })
            );
            if (editModalCloser) editModalCloser.click();
          },
        });
      }
    });
  }

  removeWhitespace(event: any): void {
    setTimeout(() => {
      event.target.value = event.target.value.replace(/\s/g, '');
      this.productLinkNgModel = event.target.value;
    });
  }

  availableVendor: string = '';
  getVendorFromUrl(url: string): string | null {
    const domainPattern: RegExp = /(?:http[s]?:\/\/)?(?:www\.)?([^\/\n\s]+)/;
    const match: RegExpMatchArray | null = url.match(domainPattern);
    if (match && match[1]) {
      if (this.availableVendor == '') {
        this.availableVendor = match[1];
      }
      return match[1];
    } else {
      return null;
    }
  }

  checkUrl(url: string): boolean {
    const vendor: string | null = this.getVendorFromUrl(url);
    if (vendor) {
      if (this.availableVendor == vendor) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  checkKey(event: KeyboardEvent): void {
    const keyCode = event.key;
    const inputValue = (event.target as HTMLInputElement).value;
    const decimalCount = inputValue.split('.').length - 1;
    const allowedCharacters =
      /[0-9.\b]|Delete|Backspace|ArrowLeft|ArrowRight|ArrowUp|ArrowDown/;
    if (!allowedCharacters.test(keyCode)) {
      event.preventDefault();
      return;
    }

    if (keyCode === '.' && decimalCount >= 1) {
      event.preventDefault();
    }
  }
  checkValue(event: any) {
    const inputValue = event.target.value;
    if (inputValue === null || inputValue === '' || isNaN(inputValue)) {
      event.target.value = '0';
    }
  }
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedInput: string = clipboardData.getData('text');
    const sanitizedInput: string = this.sanitizeInput(pastedInput);
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = sanitizedInput;
  }

  sanitizeInput(input: string): string {
    const sanitizedInput = input.replace(/\s+/g, '').replace(/[^0-9.,]/g, '');
    return sanitizedInput
      ? parseFloat(sanitizedInput.replace(',', '.')).toFixed(2)
      : '';
  }
}
